import { createRoot } from 'react-dom/client';
import App from './App';
import 'normalize.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import './assets/styles/index.scss';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

// @ts-ignore
root.render(<App />);
